<div class="container">
  <lib-shop-section
    [shopItems]="shopService.shopItems"
    [layout]="shopLayout">
  </lib-shop-section>
</div>
